import { Link, useLocation } from "react-router-dom";

const TABS = [
  { suffix: "", label: "Catalog" },
  { suffix: "/members", label: "Members" },
  { suffix: "/analytics", label: "Adoption" },
  { suffix: "/queue", label: "Queue" },
  { suffix: "/audit", label: "Audit" },
  { suffix: "/billing", label: "Billing" },
  { suffix: "/setup", label: "Get set up" },
];

export function OrgTabs({ slug }) {
  const { pathname } = useLocation();
  return (
    <div className="mb-6 inline-flex flex-wrap gap-1 rounded-xl border border-[color:var(--rb-border)] bg-[color:var(--rb-code)] p-1" data-testid="org-tabs">
      {TABS.map((t) => {
        const to = `/orgs/${slug}${t.suffix}`;
        const active = pathname === to;
        return (
          <Link
            key={t.suffix}
            to={to}
            data-testid={`org-tab-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={`rounded-lg px-4 py-1.5 text-xs font-medium transition-colors ${
              active
                ? "bg-[color:rgba(45,212,191,0.14)] text-[color:var(--rb-accent)]"
                : "text-[color:var(--rb-text-dim)] hover:text-[color:var(--rb-text)]"
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </div>
  );
}
